import React from 'react'
import PropTypes from 'prop-types'
import Turbolinks from 'turbolinks'
import { prismicHelpers } from '../../helpers'
import { Link } from '../core'
import { DeseretBookComLogo } from '../core/icons'
import { Column, Menu, MenuLabel, MenuList } from '../bulma'

/**
* Main Site Footer Column component. Renders a single column to be used in the
* `Footer` component.
*/
class FooterColumn extends React.Component {
  constructor(props) {
    super(props)

    this.getColumnItems = this.getColumnItems.bind(this)
    this.renderMenuList = this.renderMenuList.bind(this)
    this.onLinkClick = this.onLinkClick.bind(this)
  }

  onLinkClick(link, e) {
    try {
      const context = JSON.parse(link.context)

      if (context.action === 'openChat') {
        e.preventDefault()

        if (window.CustomerSupport && typeof window.CustomerSupport.openChat === 'function') {
          window.CustomerSupport.openChat()
        }

        return false
      }
    } catch (error) {
      // Doesn't matter
    }

    if (link.link) {
      Turbolinks.visit(link.link)
    }
  }

  /**
  * Sorts and filters column items into a data structure that matches the
  * way they should be rendered. Groups adjacent links together into a single
  * item. Also filters items that the user doesn't have access to.
  */
  getColumnItems() {
    if (!this.props.column && !this.props.column.content) {
      return []
    }

    return this.props.column.content
      // Only display items the user has access to.
      .filter(item => prismicHelpers.userHasPermission(item))
      // Group adjacent links together.
      .reduce((items, item) => {
        if (item.type === 'link') {
          if (items.length && Array.isArray(items[items.length - 1])) {
            items[items.length - 1].push(item)
          } else {
            items.push([item])
          }
        } else {
          items.push(item)
        }

        return items
      }, [])
  }

  /**
  * Renders a grouped list of links in a MenuList.
  *
  * @param listItems {object[]} list of link items
  * @param key {integer} key prop.
  */
  renderMenuList(listItems, key) {
    return (
      <MenuList key={key}>
        { listItems.map((item, idx) => {
          const viewableClass = prismicHelpers.formatViewClasses(item)

          return (
            <li key={idx} className={viewableClass}>
              <Link
                href={item.link}
                linkRef={`f-${this.props.column.uid}-${idx + 1}`}
                aria-label={item.linkLabel || item.linkText}
                target={item.target}
                trackEvent
                eventCategory="Footer"
                eventAction={this.props.column.uid}
                eventLabel={item.linkText}
                eventValue={idx + 1}
                onClick={e => this.onLinkClick(item, e)}
              >
                { item.linkText }
              </Link>
            </li>
          )
        }) }
      </MenuList>
    )
  }

  /**
  * Renders a single column for the footer.
  *
  * @param column {object}
  * @param key {string}
  */
  render() {
    const viewableClass = prismicHelpers.formatViewClasses(this.props.column)


    const menuItems = this.getColumnItems()

    if (!menuItems.length) return false

    return (
      <Column
        className={viewableClass}
        size="half-mobile"
      >
        <Menu isInverted={this.props.isInverted}>
          { menuItems.map((item, idx) => {
            if (Array.isArray(item)) {
              return this.renderMenuList(item, idx)
            }
              const itemViewableClass = prismicHelpers.formatViewClasses(item)

              return <MenuLabel label={item.title} key={idx} className={itemViewableClass} />
          }) }
        </Menu>
      </Column>
    )
  }
}

FooterColumn.defaultProps = {
  isInverted: false,
}

FooterColumn.propTypes = {
  column: PropTypes.object.isRequired,
  isInverted: PropTypes.bool,
}

export default FooterColumn
